import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Card from '@mui/material/Card';
import {
  CardContent,
  Container,
  Divider,
  Stack,
  Typography,
} from '@mui/material';
import { Box } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { useTranslation } from 'react-i18next';

// import ScreenWrapper from '../../../components/wrappers/ScreenWrapper';

// import AccountListItem from './AccountListItem';
import InputForm from '../../../components/forms/InputForm';
import { queryStatus } from '../../../shared/utils/queryUtils';
import {
  getProductItems,
  getProductUnits,
} from '../../../controllers/settings/inventoryControllers';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/buttons/Button';
import ScreenWrapper from '../../../components/wrappers/ScreenWrapper';
import {
  TableRowStyled,
  TbRowHeaderStyled,
} from '../../../components/styled/TableRowStyled';
import {
  TbCellBody,
  TbCellHeader,
} from '../../../components/styled/TableCellStyled';

const ProductUnitListPage = (): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const unitsQuery = useQuery(['productUnits'], getProductUnits);
  const { data = [], isLoading, isError } = unitsQuery;
  // console.log('data', data);

  return (
    <Card sx={{ minWidth: 275, paddingX: 4 }}>
      <CardContent>
        <Stack pb={2} direction={'row'} alignItems={'center'} spacing={2}>
          <Box flex={1}>
            <Grid
              container
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              alignItems={'center'}>
              <Grid xs={8}>
                <Typography
                  sx={{ fontSize: 20 }}
                  color="text.primary"
                  gutterBottom>
                  {t('settingStack.productUnits')} ({data.length})
                </Typography>
              </Grid>
              <Grid xs={4}>
                {/* <InputForm
                  size="small"
                  label={'search account by name, code or type...'}
                  onChangeText={(v: string) => onSearch(String(v))}
                /> */}
              </Grid>
            </Grid>
          </Box>
          <Box>
            <Button
              title="Add Product Unit"
              onClick={() =>
                navigate('/settings/product-units/create', { replace: true })
              }
            />
          </Box>
        </Stack>

        <Divider />

        <ScreenWrapper {...{ isLoading, isError, isEmpty: !data.length }}>
          <TableContainer>
            <Table aria-label="table">
              <TableHead>
                <TbRowHeaderStyled>
                  <TbCellHeader sx={{ width: 36 }}>SN</TbCellHeader>
                  <TbCellHeader>Product Unit Name</TbCellHeader>
                  <TbCellHeader>Product Unit Code</TbCellHeader>
                  {/* <TableCell align="right">Created At</TableCell> */}
                </TbRowHeaderStyled>
              </TableHead>
              <TableBody>
                {data.map((row, index) => (
                  <TableRowStyled key={row.id}>
                    <TbCellBody sx={{ width: 36 }}>{index + 1}</TbCellBody>

                    <TbCellBody>{row.onlyName}</TbCellBody>
                    <TbCellBody>{row.code}</TbCellBody>
                    {/* <TableCell align="right">{row.createdAt}</TableCell> */}
                  </TableRowStyled>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </ScreenWrapper>
      </CardContent>
    </Card>
  );
};

export default ProductUnitListPage;
